import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';
import { Box, Button, Card, Container, createTheme, Grid, IconButton, ThemeProvider, Toolbar } from '@mui/material';
import ProfileIcon from "../../assets/images/profile_icon.png"
import { useEffect, useState } from 'react';

interface ResultClassLabelProps {
    labelcolour: string,
    value: string,
}

const ResultClassLabel: React.FC<ResultClassLabelProps> = (props) => {
    const { labelcolour } = props;
    const { value } = props;
    const [labelcolourdata, setLabelColourData] = useState<any>()
    const [valuedata, setValueData] = useState<any>()

    useEffect(() => {
        const labelcolour_data = labelcolour
        const value_data = value
        setLabelColourData(labelcolour_data)
        setValueData(value_data)
    }, [value]);

    return (
        <Box
            sx={{
                // mt: 1, 
                // mb: 1, 
                p: 0.7,
                fontWeight: 'bold',
                // paddingX: 1.5,
                background: labelcolourdata,
                color: "white",
                textTransform: 'none',
                minWidth: '160px',
                fontSize: 14,
                // width: '100%',
                // height: '100%',
                textAlign: 'center'
            }}
        >
            {valuedata}
        </Box>
    );
}

export default ResultClassLabel;